export default function AuthCallback() {
  const urlParams = new URLSearchParams(window.location.search);
  const _desktopLoginUrl = `chrome://halo-chat-app/login`;
  if (!location.href.includes(_desktopLoginUrl)) {
    location.href = `${_desktopLoginUrl}?${urlParams.toString()}`;
  }
  return null;
}
